import { render } from "./LinearGauge.vue?vue&type=template&id=0fabfafa&scoped=true"
import script from "./LinearGauge.vue?vue&type=script&lang=js"
export * from "./LinearGauge.vue?vue&type=script&lang=js"

import "./LinearGauge.vue?vue&type=style&index=0&id=0fabfafa&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fabfafa"]])

export default __exports__